import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useContent } from "@/contexts/ContentContext";
import { CMS } from "@/constants/testIds/cms";
import { toast } from "sonner";

export function AuthModal({ open, onOpenChange }) {
  const { adminExists, login, register } = useAuth();
  const { setEditMode } = useContent();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");

  const mode = adminExists ? "login" : "create";

  useEffect(() => {
    if (open) {
      setEmail("");
      setPassword("");
      setConfirm("");
      setError("");
    }
  }, [open]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    if (mode === "create") {
      if (!email || !password) {
        setError("Email and password are both required.");
        return;
      }
      if (password !== confirm) {
        setError("Passwords do not match.");
        return;
      }
      const res = await register(email, password, "Admin");
      if (!res.ok) {
        setError(res.error);
        return;
      }
      onOpenChange(false);
      setEditMode(true);
      toast.success("Account created — you are logged in");
    } else {
      const res = await login(email, password);
      if (!res.ok) {
        setError(res.error);
        return;
      }
      onOpenChange(false);
      setEditMode(true);
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="cms-dialog">
        <DialogHeader>
          <DialogTitle>{mode === "create" ? "Create admin account" : "Admin login"}</DialogTitle>
          <DialogDescription>
            {mode === "create"
              ? "No admin account exists yet for this site. Set an email and password to manage it."
              : "Log in to edit this site."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="cms-form">
          <Input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid={CMS.authEmailInput}
            autoComplete="off"
          />
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid={CMS.authPasswordInput}
          />
          {mode === "create" && (
            <Input
              type="password"
              placeholder="Confirm password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              data-testid={CMS.authConfirmInput}
            />
          )}
          {error && (
            <div className="err" data-testid={CMS.authError}>
              {error}
            </div>
          )}
          <DialogFooter>
            <Button type="submit" data-testid={CMS.authSubmitButton}>
              {mode === "create" ? "Create account" : "Log in"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
